import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { selectContent } from "../services/basket";
import { parameterize } from "../utils/string";
import ResponsiveImage from "./responsive-image";

const Featured = ({ featured, skipLazyLoading = false }) => {
  // We no longer need to fetch the imageHost from site metadata
  // since we're using the ResponsiveImage component which handles this internally

  return (
    <div className="w-full flex flex-row flex-wrap my-2 gap-0 justify-between">
      {featured.map((f) => {
        return(
            <Link
              key={`featured-${f.frontmatter.vid}`}
              className="w-1/3 md:w-1/6"
              to={`/videos${ parameterize(f.fields.slug) }` }
              onClick={() => selectContent({ contentType: `featured`, itemId: f.frontmatter.title })}
              onKeyDown={() => selectContent({ contentType: `featured`, itemId: f.frontmatter.title })}>
              <div className="w-full relative" style={{ aspectRatio: '16/9' }}>
                <ResponsiveImage
                  src={f.frontmatter.hero}
                  alt={`featured video ${f.frontmatter.title}`}
                  className="w-full h-full object-cover absolute inset-0"
                  layout="featured"
                  skipLazyLoading={skipLazyLoading}
                  imgAttributes={{
                    key: `featured-${f.frontmatter.vid}`,
                    'data-component': 'featured-image',
                    'data-vid': f.frontmatter.vid,
                    'data-title': parameterize(f.frontmatter.title)
                  }}
                />
              </div>
            </Link>
        )
      })
      }
    </div>
  )
}

Featured.propTypes = {
  featured : PropTypes.array.isRequired,
  skipLazyLoading: PropTypes.bool
}

export default Featured
